import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FilledTextFieldComponent } from './filled-text-field.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    FilledTextFieldComponent
  ],
  exports: [
    FilledTextFieldComponent
  ]
})
export class FilledTextFieldModule {
}
